import { render, staticRenderFns } from "./SimpleSynthesisSIM.vue?vue&type=template&id=545e5140&"
import script from "./SimpleSynthesisSIM.vue?vue&type=script&lang=ts&"
export * from "./SimpleSynthesisSIM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports